/* eslint-disable react/jsx-no-literals */
import { commonMessages } from '@/__scripts/common.messages';
import HelpIcon from '@/assets/icons/help.svg?react';
import { T } from '@/components/i18n/message.i18n.component';
import Button from '@/components/ui/button/button.component';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover/popover.component';
import { cn } from '@/lib/utils';
import { useState } from 'react';

export const Help = () => {
  const [openPopover, setOpenPopover] = useState(false);

  const handleServicePortal = () => {
    const url =
      'https://siemensqaone.service-now.com/myitportal?id=myit_create_record&sys_id=1972f722db51a74003d6755d3b961968&sysparm_function=sm4apps&sysparm_l1=CT0011702&sysparm_l2=CT0102082&sysparm_l3=CT0102101&sysparm_user_impact=&sysparm_appinfo=&sysparm_subject=&sysparm_desc=';
    window.open(url, '_blank');
  };

  return (
    <Popover
      open={openPopover}
      onOpenChange={() => {
        setOpenPopover(!openPopover);
      }}
    >
      <PopoverTrigger aria-label="help menu" asChild>
        <Button aria-label="help bell icon" data-testid="help-trigger" variant="navbar-icon">
          <HelpIcon data-testid="navbar-help-icon" className="group-focus-visible:text-primary" />
        </Button>
      </PopoverTrigger>
      <PopoverContent
        data-testid="help-content"
        align="center"
        side="bottom"
        sideOffset={24}
        className="min-w-[360px] p-4"
      >
        <Button
          variant="ghost"
          onClick={handleServicePortal}
          className={cn(
            'typo-secondary leading-6 relative flex w-full cursor-pointer select-none items-center rounded',
            'mb-1 py-1 pl-3 outline-none hover:bg-light-gray hover:no-underline',
            'flex flex-row justify-start',
          )}
        >
          <p className="typo-secondary text-center">
            <T {...commonMessages.servicePortal} />
          </p>
        </Button>
      </PopoverContent>
    </Popover>
  );
};
